export default (text) => {
  return typeof text == 'string' ? text.replace(/&lt;/g, '<').replace(/&gt;/g, '>') : text;
};
